<template>
  <admin-wrapper title-translation-path="admin.QUICK_PRINT" :module-enabler="moduleEnabler" :has-buttons="false" />
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';

export default {
  name: 'QuickPrintSettings',
  components: {
    AdminWrapper,
  },
  computed: {
    moduleEnabler() {
      return {
        name: 'quick_print_module_enabled',
        translationPath: 'admin.QUICK_PRINT',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.QUICK_PRINT') }),
      };
    },
  },
};
</script>
